import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';

export interface MatchStartErrorDialogData {
  title: string;
  message: string;
  isPartialLockError?: boolean;
  isParticipantWarningError?: boolean;
  participants?: Array<{ id: string; enisNumber: string; type: 'donor' | 'recipient'; warnings: string[] }>;
}

@Component({
  selector: 'app-match-start-error-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatIconModule, CommonModule],
  templateUrl: './match-start-error-dialog.component.html',
  styleUrl: './match-start-error-dialog.component.scss'
})
export class MatchStartErrorDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<MatchStartErrorDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MatchStartErrorDialogData,
    private router: Router,
    private dialog: MatDialog
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  navigateToParticipant(participantId: string): void {
    // Close all dialogs (in case there are nested dialogs open)
    this.dialog.closeAll();

    // Navigate to participants screen with the participant expanded
    this.router.navigate(['/participants'], {
      queryParams: { expandId: participantId }
    });
  }

  // Extract unlocked chain numbers from the error message
  get unlockedChains(): string[] {
    const match = this.data.message.match(/Unlocked (?:chain|chains): ([\d, ]+)/);
    if (match && match[1]) {
      return match[1].split(',').map(s => s.trim());
    }
    return [];
  }

  // Get the main message without the chain numbers
  get mainMessage(): string {
    return this.data.message.split('Unlocked')[0].trim();
  }

  // Get participants grouped by type for display
  get donorsWithWarnings(): Array<{ id: string; enisNumber: string; warnings: string[] }> {
    return this.data.participants?.filter(p => p.type === 'donor') || [];
  }

  get recipientsWithWarnings(): Array<{ id: string; enisNumber: string; warnings: string[] }> {
    return this.data.participants?.filter(p => p.type === 'recipient') || [];
  }
}
